import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp32};
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: start;
  gap: ${props => props.theme.spacing.sp40};

  @media screen and (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`

export const ProductCard = styled.div`
  display: flex;
  padding: ${props => props.theme.spacing.sp16};
  border-radius: ${props => props.theme.radius.card};
  background-color: ${props => props.theme.colors.background.primary};
  box-shadow: ${props => props.theme.elevation.elevation2};
`
